// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/booking.proto (package trade.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/booking.proto.
 */
export const file_trade_v1_booking: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_types]);

/**
 * Request message for checking search permissions on bookings
 *
 * @generated from message trade.v1.CheckBookingSearchPermissionsRequest
 */
export type CheckBookingSearchPermissionsRequest = Message<"trade.v1.CheckBookingSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message trade.v1.CheckBookingSearchPermissionsRequest.
 * Use `create(CheckBookingSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckBookingSearchPermissionsRequestSchema: GenMessage<CheckBookingSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 0);

/**
 * Response message for the CheckBookingSearchPermissions RPC
 *
 * @generated from message trade.v1.CheckBookingSearchPermissionsResponse
 */
export type CheckBookingSearchPermissionsResponse = Message<"trade.v1.CheckBookingSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string permitted_ids = 1;
   */
  permittedIds: string[];
};

/**
 * Describes the message trade.v1.CheckBookingSearchPermissionsResponse.
 * Use `create(CheckBookingSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckBookingSearchPermissionsResponseSchema: GenMessage<CheckBookingSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 1);

/**
 * AffectedLoad represents minimal load info for deletion/void validation
 *
 * @generated from message trade.v1.AffectedLoad
 */
export type AffectedLoad = Message<"trade.v1.AffectedLoad"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string document_number = 2;
   */
  documentNumber: string;
};

/**
 * Describes the message trade.v1.AffectedLoad.
 * Use `create(AffectedLoadSchema)` to create a new message.
 */
export const AffectedLoadSchema: GenMessage<AffectedLoad> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 2);

/**
 * PhotoRequirement represents a photo requirement for a booking
 *
 * @generated from message trade.v1.PhotoRequirement
 */
export type PhotoRequirement = Message<"trade.v1.PhotoRequirement"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * @generated from field: bool required = 2;
   */
  required: boolean;
};

/**
 * Describes the message trade.v1.PhotoRequirement.
 * Use `create(PhotoRequirementSchema)` to create a new message.
 */
export const PhotoRequirementSchema: GenMessage<PhotoRequirement> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 3);

/**
 * Booking represents a shipping booking
 *
 * @generated from message trade.v1.Booking
 */
export type Booking = Message<"trade.v1.Booking"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string document_number = 2;
   */
  documentNumber: string;

  /**
   * @generated from field: trade.v1.BookingStatus status = 3;
   */
  status: BookingStatus;

  /**
   * @generated from field: string purchase_order_id = 4;
   */
  purchaseOrderId: string;

  /**
   * @generated from field: string purchase_order_number = 5;
   */
  purchaseOrderNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp cut_off_date = 6;
   */
  cutOffDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp early_return_date = 7;
   */
  earlyReturnDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vessel_arrival_date = 8;
   */
  vesselArrivalDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vessel_departure_date = 9;
   */
  vesselDepartureDate?: Timestamp;

  /**
   * @generated from field: string vessel_name = 10;
   */
  vesselName: string;

  /**
   * @generated from field: string carrier_id = 11;
   */
  carrierId: string;

  /**
   * @generated from field: string loading_port_id = 12;
   */
  loadingPortId: string;

  /**
   * @generated from field: string pickup_terminal_id = 13;
   */
  pickupTerminalId: string;

  /**
   * @generated from field: string destination_port_id = 14;
   */
  destinationPortId: string;

  /**
   * @generated from field: string dropoff_terminal_id = 15;
   */
  dropoffTerminalId: string;

  /**
   * @generated from field: string steamship_line = 16;
   */
  steamshipLine: string;

  /**
   * @generated from field: string ocean_freight = 17;
   */
  oceanFreight: string;

  /**
   * @generated from field: string freight_forwarder = 18;
   */
  freightForwarder: string;

  /**
   * @generated from field: string internal_notes = 19;
   */
  internalNotes: string;

  /**
   * @generated from field: string external_notes = 20;
   */
  externalNotes: string;

  /**
   * @generated from field: repeated trade.v1.PhotoRequirement photo_requirements = 21;
   */
  photoRequirements: PhotoRequirement[];

  /**
   * @generated from field: types.Base base = 22;
   */
  base?: Base;

  /**
   * @generated from field: string facility_id = 23;
   */
  facilityId: string;
};

/**
 * Describes the message trade.v1.Booking.
 * Use `create(BookingSchema)` to create a new message.
 */
export const BookingSchema: GenMessage<Booking> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 4);

/**
 * BookingFilter represents filter options for bookings
 *
 * @generated from message trade.v1.BookingFilter
 */
export type BookingFilter = Message<"trade.v1.BookingFilter"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * @generated from field: repeated trade.v1.BookingStatus status = 2;
   */
  status: BookingStatus[];

  /**
   * @generated from field: string document_number = 3;
   */
  documentNumber: string;

  /**
   * @generated from field: repeated string carrier_ids = 4;
   */
  carrierIds: string[];

  /**
   * @generated from field: repeated string purchase_order_ids = 5;
   */
  purchaseOrderIds: string[];

  /**
   * @generated from field: google.protobuf.Timestamp from_cut_off_date = 6;
   */
  fromCutOffDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp to_cut_off_date = 7;
   */
  toCutOffDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp from_departure_date = 8;
   */
  fromDepartureDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp to_departure_date = 9;
   */
  toDepartureDate?: Timestamp;

  /**
   * @generated from field: string search_term = 10;
   */
  searchTerm: string;

  /**
   * @generated from field: string organization_id = 11;
   */
  organizationId: string;

  /**
   * @generated from field: int32 offset = 12;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 13;
   */
  limit: number;

  /**
   * @generated from field: repeated string sorting = 14;
   */
  sorting: string[];

  /**
   * @generated from field: repeated types.ID created_by = 15;
   */
  createdBy: ID[];

  /**
   * @generated from field: repeated types.ID updated_by = 16;
   */
  updatedBy: ID[];
};

/**
 * Describes the message trade.v1.BookingFilter.
 * Use `create(BookingFilterSchema)` to create a new message.
 */
export const BookingFilterSchema: GenMessage<BookingFilter> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 5);

/**
 * GetBookingRequest is a request to get a booking by ID
 *
 * @generated from message trade.v1.GetBookingRequest
 */
export type GetBookingRequest = Message<"trade.v1.GetBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message trade.v1.GetBookingRequest.
 * Use `create(GetBookingRequestSchema)` to create a new message.
 */
export const GetBookingRequestSchema: GenMessage<GetBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 6);

/**
 * GetBookingResponse is a response containing a booking
 *
 * @generated from message trade.v1.GetBookingResponse
 */
export type GetBookingResponse = Message<"trade.v1.GetBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.GetBookingResponse.
 * Use `create(GetBookingResponseSchema)` to create a new message.
 */
export const GetBookingResponseSchema: GenMessage<GetBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 7);

/**
 * ListBookingsRequest is a request to list bookings with filtering
 *
 * @generated from message trade.v1.ListBookingsRequest
 */
export type ListBookingsRequest = Message<"trade.v1.ListBookingsRequest"> & {
  /**
   * @generated from field: trade.v1.BookingFilter filter = 1;
   */
  filter?: BookingFilter;
};

/**
 * Describes the message trade.v1.ListBookingsRequest.
 * Use `create(ListBookingsRequestSchema)` to create a new message.
 */
export const ListBookingsRequestSchema: GenMessage<ListBookingsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 8);

/**
 * ListBookingsResponse is a response containing a list of bookings
 *
 * @generated from message trade.v1.ListBookingsResponse
 */
export type ListBookingsResponse = Message<"trade.v1.ListBookingsResponse"> & {
  /**
   * @generated from field: repeated trade.v1.Booking bookings = 1;
   */
  bookings: Booking[];

  /**
   * @generated from field: int32 total_results = 2;
   */
  totalResults: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message trade.v1.ListBookingsResponse.
 * Use `create(ListBookingsResponseSchema)` to create a new message.
 */
export const ListBookingsResponseSchema: GenMessage<ListBookingsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 9);

/**
 * BookingInput is the input for creating a booking
 *
 * @generated from message trade.v1.BookingInput
 */
export type BookingInput = Message<"trade.v1.BookingInput"> & {
  /**
   * @generated from field: string document_number = 1;
   */
  documentNumber: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string purchase_order_id = 3;
   */
  purchaseOrderId: string;

  /**
   * @generated from field: string purchase_order_number = 4;
   */
  purchaseOrderNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp cut_off_date = 5;
   */
  cutOffDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp early_return_date = 6;
   */
  earlyReturnDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vessel_arrival_date = 7;
   */
  vesselArrivalDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vessel_departure_date = 8;
   */
  vesselDepartureDate?: Timestamp;

  /**
   * @generated from field: string vessel_name = 9;
   */
  vesselName: string;

  /**
   * @generated from field: string carrier_id = 10;
   */
  carrierId: string;

  /**
   * @generated from field: string loading_port_id = 11;
   */
  loadingPortId: string;

  /**
   * @generated from field: string pickup_terminal_id = 12;
   */
  pickupTerminalId: string;

  /**
   * @generated from field: string destination_port_id = 13;
   */
  destinationPortId: string;

  /**
   * @generated from field: string dropoff_terminal_id = 14;
   */
  dropoffTerminalId: string;

  /**
   * @generated from field: string steamship_line = 15;
   */
  steamshipLine: string;

  /**
   * @generated from field: string ocean_freight = 16;
   */
  oceanFreight: string;

  /**
   * @generated from field: string freight_forwarder = 17;
   */
  freightForwarder: string;

  /**
   * @generated from field: string internal_notes = 18;
   */
  internalNotes: string;

  /**
   * @generated from field: string external_notes = 19;
   */
  externalNotes: string;

  /**
   * @generated from field: repeated trade.v1.PhotoRequirement photo_requirements = 20;
   */
  photoRequirements: PhotoRequirement[];
};

/**
 * Describes the message trade.v1.BookingInput.
 * Use `create(BookingInputSchema)` to create a new message.
 */
export const BookingInputSchema: GenMessage<BookingInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 10);

/**
 * StringValue represents an optional string value
 *
 * @generated from message trade.v1.StringValue
 */
export type StringValue = Message<"trade.v1.StringValue"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message trade.v1.StringValue.
 * Use `create(StringValueSchema)` to create a new message.
 */
export const StringValueSchema: GenMessage<StringValue> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 11);

/**
 * TimestampValue represents an optional timestamp value
 *
 * @generated from message trade.v1.TimestampValue
 */
export type TimestampValue = Message<"trade.v1.TimestampValue"> & {
  /**
   * @generated from field: google.protobuf.Timestamp value = 1;
   */
  value?: Timestamp;
};

/**
 * Describes the message trade.v1.TimestampValue.
 * Use `create(TimestampValueSchema)` to create a new message.
 */
export const TimestampValueSchema: GenMessage<TimestampValue> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 12);

/**
 * PhotoRequirementList represents a list of photo requirements
 *
 * @generated from message trade.v1.PhotoRequirementList
 */
export type PhotoRequirementList = Message<"trade.v1.PhotoRequirementList"> & {
  /**
   * @generated from field: repeated trade.v1.PhotoRequirement photo_requirements = 1;
   */
  photoRequirements: PhotoRequirement[];
};

/**
 * Describes the message trade.v1.PhotoRequirementList.
 * Use `create(PhotoRequirementListSchema)` to create a new message.
 */
export const PhotoRequirementListSchema: GenMessage<PhotoRequirementList> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 13);

/**
 * BookingUpdateInput is the input for updating a booking
 *
 * @generated from message trade.v1.BookingUpdateInput
 */
export type BookingUpdateInput = Message<"trade.v1.BookingUpdateInput"> & {
  /**
   * @generated from field: trade.v1.StringValue document_number = 1;
   */
  documentNumber?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue status = 2;
   */
  status?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue purchase_order_id = 3;
   */
  purchaseOrderId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue purchase_order_number = 4;
   */
  purchaseOrderNumber?: StringValue;

  /**
   * @generated from field: trade.v1.TimestampValue cut_off_date = 5;
   */
  cutOffDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.TimestampValue early_return_date = 6;
   */
  earlyReturnDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.TimestampValue vessel_arrival_date = 7;
   */
  vesselArrivalDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.TimestampValue vessel_departure_date = 8;
   */
  vesselDepartureDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.StringValue vessel_name = 9;
   */
  vesselName?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue carrier_id = 10;
   */
  carrierId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue loading_port_id = 11;
   */
  loadingPortId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue pickup_terminal_id = 12;
   */
  pickupTerminalId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue destination_port_id = 13;
   */
  destinationPortId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue dropoff_terminal_id = 14;
   */
  dropoffTerminalId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue steamship_line = 15;
   */
  steamshipLine?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue ocean_freight = 16;
   */
  oceanFreight?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue freight_forwarder = 17;
   */
  freightForwarder?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue internal_notes = 18;
   */
  internalNotes?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue external_notes = 19;
   */
  externalNotes?: StringValue;

  /**
   * @generated from field: trade.v1.PhotoRequirementList photo_requirements = 20;
   */
  photoRequirements?: PhotoRequirementList;
};

/**
 * Describes the message trade.v1.BookingUpdateInput.
 * Use `create(BookingUpdateInputSchema)` to create a new message.
 */
export const BookingUpdateInputSchema: GenMessage<BookingUpdateInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 14);

/**
 * CreateBookingRequest is a request to create a new booking
 *
 * @generated from message trade.v1.CreateBookingRequest
 */
export type CreateBookingRequest = Message<"trade.v1.CreateBookingRequest"> & {
  /**
   * @generated from field: trade.v1.BookingInput input = 1;
   */
  input?: BookingInput;
};

/**
 * Describes the message trade.v1.CreateBookingRequest.
 * Use `create(CreateBookingRequestSchema)` to create a new message.
 */
export const CreateBookingRequestSchema: GenMessage<CreateBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 15);

/**
 * CreateBookingResponse is a response containing the created booking
 *
 * @generated from message trade.v1.CreateBookingResponse
 */
export type CreateBookingResponse = Message<"trade.v1.CreateBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.CreateBookingResponse.
 * Use `create(CreateBookingResponseSchema)` to create a new message.
 */
export const CreateBookingResponseSchema: GenMessage<CreateBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 16);

/**
 * UpdateBookingRequest is a request to update an existing booking
 *
 * @generated from message trade.v1.UpdateBookingRequest
 */
export type UpdateBookingRequest = Message<"trade.v1.UpdateBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: trade.v1.BookingUpdateInput input = 2;
   */
  input?: BookingUpdateInput;
};

/**
 * Describes the message trade.v1.UpdateBookingRequest.
 * Use `create(UpdateBookingRequestSchema)` to create a new message.
 */
export const UpdateBookingRequestSchema: GenMessage<UpdateBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 17);

/**
 * UpdateBookingResponse is a response containing the updated booking
 *
 * @generated from message trade.v1.UpdateBookingResponse
 */
export type UpdateBookingResponse = Message<"trade.v1.UpdateBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.UpdateBookingResponse.
 * Use `create(UpdateBookingResponseSchema)` to create a new message.
 */
export const UpdateBookingResponseSchema: GenMessage<UpdateBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 18);

/**
 * DeleteBookingRequest is a request to delete a booking
 *
 * @generated from message trade.v1.DeleteBookingRequest
 */
export type DeleteBookingRequest = Message<"trade.v1.DeleteBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message trade.v1.DeleteBookingRequest.
 * Use `create(DeleteBookingRequestSchema)` to create a new message.
 */
export const DeleteBookingRequestSchema: GenMessage<DeleteBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 19);

/**
 * DeleteBookingResponse is a response indicating the success of deletion
 *
 * @generated from message trade.v1.DeleteBookingResponse
 */
export type DeleteBookingResponse = Message<"trade.v1.DeleteBookingResponse"> & {
};

/**
 * Describes the message trade.v1.DeleteBookingResponse.
 * Use `create(DeleteBookingResponseSchema)` to create a new message.
 */
export const DeleteBookingResponseSchema: GenMessage<DeleteBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 20);

/**
 * DraftBookingInput is the input for creating a draft booking
 *
 * @generated from message trade.v1.DraftBookingInput
 */
export type DraftBookingInput = Message<"trade.v1.DraftBookingInput"> & {
  /**
   * @generated from field: string document_number = 1;
   */
  documentNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp cut_off_date = 2;
   */
  cutOffDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp early_return_date = 3;
   */
  earlyReturnDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vessel_arrival_date = 4;
   */
  vesselArrivalDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp vessel_departure_date = 5;
   */
  vesselDepartureDate?: Timestamp;

  /**
   * @generated from field: string vessel_name = 6;
   */
  vesselName: string;

  /**
   * @generated from field: string loading_port_id = 7;
   */
  loadingPortId: string;

  /**
   * @generated from field: string pickup_terminal_id = 8;
   */
  pickupTerminalId: string;

  /**
   * @generated from field: string destination_port_id = 9;
   */
  destinationPortId: string;

  /**
   * @generated from field: string dropoff_terminal_id = 10;
   */
  dropoffTerminalId: string;

  /**
   * @generated from field: string steamship_line = 11;
   */
  steamshipLine: string;

  /**
   * @generated from field: string ocean_freight = 12;
   */
  oceanFreight: string;

  /**
   * @generated from field: string internal_notes = 13;
   */
  internalNotes: string;

  /**
   * @generated from field: string external_notes = 14;
   */
  externalNotes: string;

  /**
   * @generated from field: repeated trade.v1.PhotoRequirement photo_requirements = 15;
   */
  photoRequirements: PhotoRequirement[];
};

/**
 * Describes the message trade.v1.DraftBookingInput.
 * Use `create(DraftBookingInputSchema)` to create a new message.
 */
export const DraftBookingInputSchema: GenMessage<DraftBookingInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 21);

/**
 * DraftBookingUpdateInput is the input for updating a draft booking
 *
 * @generated from message trade.v1.DraftBookingUpdateInput
 */
export type DraftBookingUpdateInput = Message<"trade.v1.DraftBookingUpdateInput"> & {
  /**
   * @generated from field: trade.v1.StringValue document_number = 1;
   */
  documentNumber?: StringValue;

  /**
   * @generated from field: trade.v1.TimestampValue cut_off_date = 2;
   */
  cutOffDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.TimestampValue early_return_date = 3;
   */
  earlyReturnDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.TimestampValue vessel_arrival_date = 4;
   */
  vesselArrivalDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.TimestampValue vessel_departure_date = 5;
   */
  vesselDepartureDate?: TimestampValue;

  /**
   * @generated from field: trade.v1.StringValue vessel_name = 6;
   */
  vesselName?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue loading_port_id = 7;
   */
  loadingPortId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue pickup_terminal_id = 8;
   */
  pickupTerminalId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue destination_port_id = 9;
   */
  destinationPortId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue dropoff_terminal_id = 10;
   */
  dropoffTerminalId?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue steamship_line = 11;
   */
  steamshipLine?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue ocean_freight = 12;
   */
  oceanFreight?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue internal_notes = 13;
   */
  internalNotes?: StringValue;

  /**
   * @generated from field: trade.v1.StringValue external_notes = 14;
   */
  externalNotes?: StringValue;

  /**
   * @generated from field: trade.v1.PhotoRequirementList photo_requirements = 15;
   */
  photoRequirements?: PhotoRequirementList;
};

/**
 * Describes the message trade.v1.DraftBookingUpdateInput.
 * Use `create(DraftBookingUpdateInputSchema)` to create a new message.
 */
export const DraftBookingUpdateInputSchema: GenMessage<DraftBookingUpdateInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 22);

/**
 * CreateDraftBookingRequest is a request to create a new draft booking
 *
 * @generated from message trade.v1.CreateDraftBookingRequest
 */
export type CreateDraftBookingRequest = Message<"trade.v1.CreateDraftBookingRequest"> & {
  /**
   * @generated from field: trade.v1.DraftBookingInput input = 1;
   */
  input?: DraftBookingInput;
};

/**
 * Describes the message trade.v1.CreateDraftBookingRequest.
 * Use `create(CreateDraftBookingRequestSchema)` to create a new message.
 */
export const CreateDraftBookingRequestSchema: GenMessage<CreateDraftBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 23);

/**
 * CreateDraftBookingResponse is a response containing the created draft booking
 *
 * @generated from message trade.v1.CreateDraftBookingResponse
 */
export type CreateDraftBookingResponse = Message<"trade.v1.CreateDraftBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.CreateDraftBookingResponse.
 * Use `create(CreateDraftBookingResponseSchema)` to create a new message.
 */
export const CreateDraftBookingResponseSchema: GenMessage<CreateDraftBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 24);

/**
 * UpdateDraftBookingRequest is a request to update a draft booking
 *
 * @generated from message trade.v1.UpdateDraftBookingRequest
 */
export type UpdateDraftBookingRequest = Message<"trade.v1.UpdateDraftBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: trade.v1.DraftBookingUpdateInput input = 2;
   */
  input?: DraftBookingUpdateInput;
};

/**
 * Describes the message trade.v1.UpdateDraftBookingRequest.
 * Use `create(UpdateDraftBookingRequestSchema)` to create a new message.
 */
export const UpdateDraftBookingRequestSchema: GenMessage<UpdateDraftBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 25);

/**
 * UpdateDraftBookingResponse is a response containing the updated draft booking
 *
 * @generated from message trade.v1.UpdateDraftBookingResponse
 */
export type UpdateDraftBookingResponse = Message<"trade.v1.UpdateDraftBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.UpdateDraftBookingResponse.
 * Use `create(UpdateDraftBookingResponseSchema)` to create a new message.
 */
export const UpdateDraftBookingResponseSchema: GenMessage<UpdateDraftBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 26);

/**
 * OpenBookingRequest is a request to open a booking
 *
 * @generated from message trade.v1.OpenBookingRequest
 */
export type OpenBookingRequest = Message<"trade.v1.OpenBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message trade.v1.OpenBookingRequest.
 * Use `create(OpenBookingRequestSchema)` to create a new message.
 */
export const OpenBookingRequestSchema: GenMessage<OpenBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 27);

/**
 * OpenBookingResponse is a response containing the opened booking
 *
 * @generated from message trade.v1.OpenBookingResponse
 */
export type OpenBookingResponse = Message<"trade.v1.OpenBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.OpenBookingResponse.
 * Use `create(OpenBookingResponseSchema)` to create a new message.
 */
export const OpenBookingResponseSchema: GenMessage<OpenBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 28);

/**
 * VoidBookingRequest is a request to void a booking
 *
 * @generated from message trade.v1.VoidBookingRequest
 */
export type VoidBookingRequest = Message<"trade.v1.VoidBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool force_unlink = 2;
   */
  forceUnlink: boolean;
};

/**
 * Describes the message trade.v1.VoidBookingRequest.
 * Use `create(VoidBookingRequestSchema)` to create a new message.
 */
export const VoidBookingRequestSchema: GenMessage<VoidBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 29);

/**
 * VoidBookingResponse is a response containing the void result
 *
 * @generated from message trade.v1.VoidBookingResponse
 */
export type VoidBookingResponse = Message<"trade.v1.VoidBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;

  /**
   * @generated from field: repeated trade.v1.AffectedLoad blocking_loads = 2;
   */
  blockingLoads: AffectedLoad[];

  /**
   * @generated from field: repeated trade.v1.AffectedLoad unlinkable_loads = 3;
   */
  unlinkableLoads: AffectedLoad[];

  /**
   * @generated from field: bool requires_confirmation = 4;
   */
  requiresConfirmation: boolean;
};

/**
 * Describes the message trade.v1.VoidBookingResponse.
 * Use `create(VoidBookingResponseSchema)` to create a new message.
 */
export const VoidBookingResponseSchema: GenMessage<VoidBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 30);

/**
 * ShipBookingRequest is a request to ship a booking
 *
 * @generated from message trade.v1.ShipBookingRequest
 */
export type ShipBookingRequest = Message<"trade.v1.ShipBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp shipped_date = 2;
   */
  shippedDate?: Timestamp;
};

/**
 * Describes the message trade.v1.ShipBookingRequest.
 * Use `create(ShipBookingRequestSchema)` to create a new message.
 */
export const ShipBookingRequestSchema: GenMessage<ShipBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 31);

/**
 * ShipBookingResponse is a response containing the shipped booking
 *
 * @generated from message trade.v1.ShipBookingResponse
 */
export type ShipBookingResponse = Message<"trade.v1.ShipBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.ShipBookingResponse.
 * Use `create(ShipBookingResponseSchema)` to create a new message.
 */
export const ShipBookingResponseSchema: GenMessage<ShipBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 32);

/**
 * CompleteBookingRequest is a request to complete a booking
 *
 * @generated from message trade.v1.CompleteBookingRequest
 */
export type CompleteBookingRequest = Message<"trade.v1.CompleteBookingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message trade.v1.CompleteBookingRequest.
 * Use `create(CompleteBookingRequestSchema)` to create a new message.
 */
export const CompleteBookingRequestSchema: GenMessage<CompleteBookingRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 33);

/**
 * CompleteBookingResponse is a response containing the completed booking
 *
 * @generated from message trade.v1.CompleteBookingResponse
 */
export type CompleteBookingResponse = Message<"trade.v1.CompleteBookingResponse"> & {
  /**
   * @generated from field: trade.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message trade.v1.CompleteBookingResponse.
 * Use `create(CompleteBookingResponseSchema)` to create a new message.
 */
export const CompleteBookingResponseSchema: GenMessage<CompleteBookingResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_booking, 34);

/**
 * BookingStatus represents the status of a booking
 *
 * @generated from enum trade.v1.BookingStatus
 */
export enum BookingStatus {
  /**
   * @generated from enum value: BOOKING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_STATUS_VOIDED = 1;
   */
  VOIDED = 1,

  /**
   * @generated from enum value: BOOKING_STATUS_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * @generated from enum value: BOOKING_STATUS_OPEN = 3;
   */
  OPEN = 3,

  /**
   * @generated from enum value: BOOKING_STATUS_SHIPPED = 4;
   */
  SHIPPED = 4,

  /**
   * @generated from enum value: BOOKING_STATUS_COMPLETED = 5;
   */
  COMPLETED = 5,
}

/**
 * Describes the enum trade.v1.BookingStatus.
 */
export const BookingStatusSchema: GenEnum<BookingStatus> = /*@__PURE__*/
  enumDesc(file_trade_v1_booking, 0);

/**
 * BookingQueriesService provides read methods for booking management
 *
 * @generated from service trade.v1.BookingQueriesService
 */
export const BookingQueriesService: GenService<{
  /**
   * GetBooking retrieves a booking by ID
   *
   * @generated from rpc trade.v1.BookingQueriesService.GetBooking
   */
  getBooking: {
    methodKind: "unary";
    input: typeof GetBookingRequestSchema;
    output: typeof GetBookingResponseSchema;
  },
  /**
   * ListBookings lists bookings with filtering
   *
   * @generated from rpc trade.v1.BookingQueriesService.ListBookings
   */
  listBookings: {
    methodKind: "unary";
    input: typeof ListBookingsRequestSchema;
    output: typeof ListBookingsResponseSchema;
  },
  /**
   * CheckBookingSearchPermissions checks which of the provided booking IDs the user has permission to access
   *
   * @generated from rpc trade.v1.BookingQueriesService.CheckBookingSearchPermissions
   */
  checkBookingSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckBookingSearchPermissionsRequestSchema;
    output: typeof CheckBookingSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_booking, 0);

/**
 * BookingCommandsService provides write methods for booking management
 *
 * @generated from service trade.v1.BookingCommandsService
 */
export const BookingCommandsService: GenService<{
  /**
   * CreateBooking creates a new booking
   *
   * @generated from rpc trade.v1.BookingCommandsService.CreateBooking
   */
  createBooking: {
    methodKind: "unary";
    input: typeof CreateBookingRequestSchema;
    output: typeof CreateBookingResponseSchema;
  },
  /**
   * CreateDraftBooking creates a new booking in draft status
   *
   * @generated from rpc trade.v1.BookingCommandsService.CreateDraftBooking
   */
  createDraftBooking: {
    methodKind: "unary";
    input: typeof CreateDraftBookingRequestSchema;
    output: typeof CreateDraftBookingResponseSchema;
  },
  /**
   * UpdateBooking updates an existing booking
   *
   * @generated from rpc trade.v1.BookingCommandsService.UpdateBooking
   */
  updateBooking: {
    methodKind: "unary";
    input: typeof UpdateBookingRequestSchema;
    output: typeof UpdateBookingResponseSchema;
  },
  /**
   * UpdateDraftBooking updates a draft booking
   *
   * @generated from rpc trade.v1.BookingCommandsService.UpdateDraftBooking
   */
  updateDraftBooking: {
    methodKind: "unary";
    input: typeof UpdateDraftBookingRequestSchema;
    output: typeof UpdateDraftBookingResponseSchema;
  },
  /**
   * DeleteBooking deletes a booking
   *
   * @generated from rpc trade.v1.BookingCommandsService.DeleteBooking
   */
  deleteBooking: {
    methodKind: "unary";
    input: typeof DeleteBookingRequestSchema;
    output: typeof DeleteBookingResponseSchema;
  },
  /**
   * Status transition methods
   *
   * @generated from rpc trade.v1.BookingCommandsService.OpenBooking
   */
  openBooking: {
    methodKind: "unary";
    input: typeof OpenBookingRequestSchema;
    output: typeof OpenBookingResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.BookingCommandsService.VoidBooking
   */
  voidBooking: {
    methodKind: "unary";
    input: typeof VoidBookingRequestSchema;
    output: typeof VoidBookingResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.BookingCommandsService.ShipBooking
   */
  shipBooking: {
    methodKind: "unary";
    input: typeof ShipBookingRequestSchema;
    output: typeof ShipBookingResponseSchema;
  },
  /**
   * @generated from rpc trade.v1.BookingCommandsService.CompleteBooking
   */
  completeBooking: {
    methodKind: "unary";
    input: typeof CompleteBookingRequestSchema;
    output: typeof CompleteBookingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_booking, 1);

